import React, {useState, useEffect, useRef} from 'react';
import {findCustomerPendingSale, findTablePendingSale} from "../../utils/requestUtils";
import {formatPhoneNumber} from "../../core/telephone";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";

function removeSpecialChars(str) {
    return (str || '').normalize("NFD").replace(/[̀-ͯ]/g, "").toUpperCase();
}

// Fechar Pedidos: só o que tem item pendente — comandas, Take Away/Delivery e mesas sem comanda.
// Cada linha abre a mesma conferência de Fechar Comanda (por cliente) ou de Fechar Mesa (por mesa).
const PendingOrderList = () => {
    const [orders, setOrders] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    useEffect(() => {
        async function makeQuery() {
            try {
                setLoading(true);
                const [customers, tables] = await Promise.all([
                    findCustomerPendingSale(''),
                    findTablePendingSale(''),
                ]);
                const customerOrders = (customers || []).map((customer) => ({
                    key: 'c' + customer.id,
                    type: customer.walkIn ? 'Take Away / Delivery' : 'Comanda',
                    name: customer.name + (customer.walkIn && customer.phone ? ` (${formatPhoneNumber(customer.phone)})` : ''),
                    search: [customer.name, customer.phone, customer.code].join(' '),
                    path: '/sale/finishitems/' + customer.id,
                }));
                const tableOrders = (tables || []).map((table) => ({
                    key: 't' + table.id,
                    type: 'Mesa',
                    name: table.name,
                    search: [table.name, table.code].join(' '),
                    path: '/sale/finishtable/' + table.id,
                }));
                setOrders(tableOrders.concat(customerOrders));
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        }

        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery();
    }, [setLoading]);

    const query = removeSpecialChars(queryString);
    const digits = queryString.replace(/\D/g, '');
    const filteredOrders = orders.filter((order) => {
        const search = removeSpecialChars(order.type + ' ' + order.search);
        return search.includes(query) || (digits !== '' && search.replace(/\D/g, '').includes(digits));
    });

    return (
        <>
            <div className="header-label">Fechar Pedidos</div>

            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}
                className="input-container">
                <input style={{width: '100%'}} ref={inputQueryString} type="text" value={queryString}
                       onChange={(e) => setQueryString(e.target.value)} onFocus={(event) => event.target.select()}/>
                <button id="clearButton" onClick={() => {
                    setQueryString('');
                    inputQueryString.current.focus();
                }}>X
                </button>
            </div>
            <div style={{flexGrow: 1, overflowY: "auto"}}>
                <table style={{width: '100%'}}>
                    <colgroup>
                        <col style={{width: '120px'}}/>
                        <col style={{width: '300px'}}/>
                        <col style={{width: '50px'}}/>
                    </colgroup>
                    <tbody style={{overflowY: 'auto'}}>
                    {filteredOrders.map((order) => (
                        <tr key={order.key}>
                            <td>{order.type}</td>
                            <td>{order.name}</td>
                            <td>
                                <button onClick={() => navigate(order.path)}>Conferir
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                    {filteredOrders.length === 0 &&
                        <tfoot>
                        <tr>
                            <td colSpan={3}>
                                Nenhum pedido pendente
                            </td>
                        </tr>
                        </tfoot>
                    }
                </table>
            </div>
        </>
    );
};

export default PendingOrderList;
